import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// VITE CHUNK LOAD ERROR PROTECTION
// This fixes the "error loading dynamically imported module" by forcing a fresh load
// if the browser tries to fetch a JS chunk that has been updated/deleted on the server.
const handleChunkError = (e: any) => {
  const msg = e?.message || e?.reason?.message || "";
  const isChunkError = 
    msg.toLowerCase().includes('loading chunk') || 
    msg.toLowerCase().includes('dynamically imported module') || 
    msg.toLowerCase().includes('failed to fetch') ||
    msg.toLowerCase().includes('preload css');

  if (isChunkError) {
    const lastReload = sessionStorage.getItem('es_last_chunk_reload');
    const now = Date.now();
    
    if (!lastReload || now - parseInt(lastReload) > 30000) {
      console.warn("Bundle mismatch or chunk load error (Top Level). Forcing reload with cache bypass...");
      sessionStorage.setItem('es_last_chunk_reload', now.toString());
      const url = new URL(window.location.href);
      url.searchParams.set('v', now.toString());
      window.location.replace(url.toString());
    }
  }
};

window.addEventListener('error', handleChunkError, true);
window.addEventListener('unhandledrejection', handleChunkError);

// Pre-warm state context if bootstrap data is present
if (typeof window !== 'undefined' && window.__BOOTSTRAP_DATA__) {
    console.log("🚀 Hydrating with server-provided bootstrap data...");
}

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);
  root.render(
    <App />
  );
} else {
  console.error("Failed to find the root element.");
}
